import React from "react";
import FeatherIcon from "feather-icons-react";
import { getGestionOptionPresentation } from "./cobranzaGestionUtils";

function toIconClassName(className) {
  if (!className) return "cf-gestion-badge-icon--neutral";
  return className.replace("cf-gestion-badge--", "cf-gestion-badge-icon--");
}

export default function CobranzaGestionStateIcon({
  className,
  icon = "minus",
  size = 12,
}) {
  return (
    <span
      className={`cf-gestion-state-icon ${toIconClassName(className)}`}
      aria-hidden="true"
    >
      <FeatherIcon icon={icon} size={size} strokeWidth={2.25} />
    </span>
  );
}

export function CobranzaGestionStateBadge({
  options,
  value,
  label,
  readOnly = true,
  className = "",
}) {
  const presentation = getGestionOptionPresentation(options, value);
  const displayLabel = label ?? (value ? presentation.label : "Sin selección");

  return (
    <span
      className={`cf-gestion-process-badge cf-gestion-process-badge--neutral${
        readOnly ? " cf-gestion-process-badge--readonly" : ""
      } ${className}`.trim()}
    >
      <span className="cf-gestion-process-badge__label">{displayLabel}</span>
      <CobranzaGestionStateIcon
        className={presentation.className}
        icon={presentation.icon}
      />
    </span>
  );
}
